import { LinkProps } from '@design-system/link';

import { mapIconToProps } from '~/mappers/common';

import { Link, LinkBase } from './models';

export const linkBaseMapper = ({ link, title, ariaLabel }: LinkBase) => {
  const [
    {
      url = undefined, // TODO fix linkBaseMapper href undefined
      fields = undefined,
      ariaLabel: externalAriaLabel = undefined,
    } = {},
  ] = link || [];

  return {
    href: fields ? fields.fullPath : url,
    title,
    ariaLabel: externalAriaLabel || ariaLabel,
  };
};

export const linkMapper = ({
  link,
  size,
  variant,
  ariaLabel,
  iconSuffix,
  iconPrefix,
  title,
  className,
  id,
}: Link) => {
  const {
    href,
    title: baseTitle,
    ariaLabel: baseAriaLabel,
  } = linkBaseMapper({ link, title });

  return {
    href,
    children: baseTitle,
    title: baseTitle,
    size: size || undefined,
    variant: variant || undefined,
    'aria-label': ariaLabel || baseAriaLabel || undefined,
    ...mapIconToProps(iconSuffix, 'iconSuffix'),
    ...mapIconToProps(iconPrefix, 'iconPrefix'),
    className,
    id,
  } as LinkProps;
};

export const optionalLinkMapper = (link: Link[]) => {
  if (link.length > 0 && link[0].link.length) {
    return linkMapper(link[0]);
  }

  return null;
};
